export default __webpack_public_path__ + "assembly271a216.png";